import { ReactNode } from 'react';
import { ConfigProvider } from 'antd';
import ru_RU from 'antd/locale/ru_RU';

export default function Theme({ children }: { children: ReactNode }) {
    return (
        <ConfigProvider
            locale={ru_RU}
            theme={{
                components: {
                    Menu: {
                        iconSize: 16,
                        itemPaddingInline: 8,
                        darkItemBg: 'rgba(0, 0, 0, 1)',
                        algorithm: true,
                    },
                    Layout: {
                        siderBg: 'rgba(0, 0, 0, 1)',
                        headerBg: 'rgba(0, 0, 0, 1)',
                    },
                },
            }}
        >
            {children}
        </ConfigProvider>
    );
}
